module.exports = __webpack_public_path__ + "img/search.25c4a2f8.png";